import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@mui/material/FormControl';
import i18n from '../../../i18n';
import MultipleSelect from './MultipleSelect';
import SingleSelect from './SingleSelect';
import { AppDataContext } from '../../../context/Context';

class FilterItemContextField extends Component {
    field;
    unsubscribe = () => {};
    previousControllersData = null;

    constructor(props) {
        super(props);
        this.state = {
            items: [],
            selectedItems: []
        };
        this.field = props.field;
    }

    static contextType = AppDataContext;

    componentDidMount() {
        this.unsubscribe = this.context.subscribe(this.fetchData);
        this.fetchData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.selectedItems !== prevState.selectedItems) {
            this.props.handleFilter(this.field.id, this.state.selectedItems);
        }
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    fetchData = () => {
        try {
            const { controllersData } = this.context.getState();
            const filterByKey = this.field.filterBy;

            const newData = controllersData?.[filterByKey];
            const oldData = this.previousControllersData?.[filterByKey];

            if (
                !newData ||
                JSON.stringify(newData) === JSON.stringify(oldData)
            ) {
                return;
            }

            this.previousControllersData = controllersData;

            this.setState({ items: newData });

            if (this.props.filters) {
                const fieldKey = this.field.id;
                const match = this.props.filters
                    .flat()
                    ?.find((f) => f.field === fieldKey);
                const id = match?.value?.[0];

                if (id) {
                    const selectedItem = newData.find((item) =>
                        typeof item === 'object'
                            ? item?.id === id
                            : item === id
                    );
                    if (selectedItem) {
                        this.setState({ selectedItems: [selectedItem] });
                    }
                }
            }

            if (this.props.param) {
                const param = Number(this.props.param);
                const selectedItem = newData.find((item) =>
                    typeof item === 'object'
                        ? item?.id === param
                        : item === param
                );
                if (selectedItem) {
                    this.setState({ selectedItems: [selectedItem] });
                }
            }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };

    handleChange = (value) => {
        this.setState({ selectedItems: value });
    };

    render() {
        const { items, selectedItems } = this.state;
        const { multiple, label, translate } = this.field;
        const translatedLabel = i18n.t(`text.filter_by_${label}`);

        return (
            <FormControl sx={{ width: '100%', maxWidth: this.props.maxWidth || '350px', m: 1, flex: '1 1 0', minWidth: '100px' }}>
                {multiple ? (
                    <MultipleSelect
                        label={translatedLabel}
                        items={items}
                        selectedItems={selectedItems}
                        helperText={this.props.helperText}
                        handleChange={this.handleChange}
                        disabled={this.props.disabled}
                    />
                ) : (
                    <SingleSelect
                        label={translatedLabel}
                        items={items}
                        selectedItem={
                            selectedItems.length ? selectedItems[0] : ''
                        }
                        handleChange={this.handleChange}
                        helperText={this.props.helperText}
                        trKey={translate}
                        disabled={this.props.disabled}
                    />
                )}
            </FormControl>
        );
    }
}

export default FilterItemContextField;

FilterItemContextField.propTypes = {
    field: PropTypes.shape({
        filterBy: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        multiple: PropTypes.bool,
        translate: PropTypes.string
    }).isRequired,
    handleFilter: PropTypes.func.isRequired
};

FilterItemContextField.defaultProps = {
    field: {
        multiple: false
    }
};
